import React from 'react';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { PanelContent, PanelFrame } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';

import { DiskBadgeWrapper } from '../styles';
import { FREE_TO_SUBSCRIPTION } from '../utils';

const FreePaymentSource = (props) => {
    const getTitle = (name) => {
        return (
            <>
                <Text>{name}</Text>
            </>
        );
    };

    const onPanelClick = () => {
        props.openClick(null, FREE_TO_SUBSCRIPTION);
    };

    return (
        <Panel onClick={onPanelClick} negativeMargin isHoverable>
            <PanelFrame>
                <DiskBadgeWrapper>
                    <DiskBadge
                        iconName={props.icon ? props.icon : null}
                        src={props.src ? props.src : null}
                        variant={props.diskVariant ? props.diskVariant : 'secondary'}
                        withoutRadius={props.withoutRadius}
                    />
                </DiskBadgeWrapper>
                <PanelContent>{getTitle(props.name)}</PanelContent>
            </PanelFrame>
        </Panel>
    );
};

export default FreePaymentSource;
